// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.surgical-container {
  padding: 20px;
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.surgical-header {
  height: 10%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-bottom: 10px;
}

.surgical-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
}

.surgical-action-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  color: #374151;
  cursor: pointer;
  font-size: 14px;
}



.recording {
  background-color: #f37777 !important;
}

.surgical-action-button:hover {
  background: #edeff0;
}

.surgical-content {
  height: 95%;
  max-width: 100%;
  overflow-y: scroll;
  line-height: 1.5;
  color: #374151;
  font-size: 16px;
  padding: 0px 16px;
}

.surgical-editor {
  width: 100%;
  height: 100%;
  min-height: 65%;
  padding: 16px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  line-height: 1.6;
  font-family: inherit;
  resize: none;
  color: #374151;
  background: white;
}

.surgical-editor:focus {
  outline: none;
}

.surgical-markdown-content {
  font-size: 14px;
  line-height: 1.6;
  color: #374151;
}

.surgical-markdown-content h1,
.surgical-markdown-content h2,
.surgical-markdown-content h3,
.surgical-markdown-content h4,
.surgical-markdown-content h5,
.surgical-markdown-content h6 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-weight: 500;
  color: #111827;
}

.surgical-markdown-content p {
  margin: 1em 0;
}

.surgical-markdown-content ul,
.surgical-markdown-content ol {
  margin: 1em 0;
  padding-left: 1.5em;
}

.surgical-markdown-content li {
  margin: 0.5em 0;
}

.surgical-recording-status-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.surgical-timer-container {
  display: flex;
  align-items: center;
  gap: 12px;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
}

.surgical-mic-icon {
  width: 20px;
  height: 20px;
  color: #0d9488;
}

.surgical-timer {
  font-size: 16px;
  font-weight: 500;
  color: #374151;
}

.surgical-waveform {
  margin-left: 8px;
}

.recording-message {
  text-align: center;
}

.recording-message h3 {
  font-size: 18px;
  color: #374151;
  margin-bottom: 8px;
}

.recording-message p {
  color: #6b7280;
  font-size: 14px;
}



.audio-player {
  height: 15%;
  width: 100%;
  border-top: 1px solid #e5e7eb;
  padding-top: 16px;
  margin-bottom: 20px;
}

.audio-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
  color: #374151;
  font-size: 14px;
}

.recording-name {
  font-weight: 500;
}

.audio-controls {
  display: flex;
  align-items: center;
  gap: 16px;
}

.play-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #374151;
  padding: 8px;
  border-radius: 50%;
}

.play-button:hover {
  background: #f3f4f6;
}

.progress-bar-container {
  flex: 1 1;
  position: relative;
}

.progress-bar {
  width: 100%;
  height: 4px;
  appearance: none;
  background: #e5e7eb;
  border-radius: 2px;
  outline: none;
  cursor: pointer;
}

.progress-bar::-webkit-slider-thumb {
  appearance: none;
  width: 12px;
  height: 12px;
  background: #0d9488;
  border-radius: 50%;
  cursor: pointer;
}

.audio-actions {
  display: flex;
  gap: 8px;
}

.audio-action-button {
  background: none;
  border: none;
  cursor: pointer;
  color: #374151;
  padding: 8px;
  border-radius: 50%;
}

.audio-action-button:hover {
  background: #f3f4f6;
}

@media (max-width: 600px) {
  .surgical-container {
    padding: 10px;
    overflow: auto;
  }
  .surgical-actions {
    padding-right: 20px;
  }
  .surgical-markdown-content {
    font-size: 14px;
    line-height: 1.4;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/selectedSurgicalComponent/SurgicalNotes.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;;;AAIA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;;;AAIA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EAEX,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;AACjB;;AAEA;EAEE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".surgical-container {\r\n  padding: 20px;\r\n  background: white;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  position: relative;\r\n}\r\n\r\n.surgical-header {\r\n  height: 10%;\r\n  width: 100%;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  align-items: center;\r\n  padding-bottom: 10px;\r\n}\r\n\r\n.surgical-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.surgical-action-button {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: white;\r\n  color: #374151;\r\n  cursor: pointer;\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n\r\n.recording {\r\n  background-color: #f37777 !important;\r\n}\r\n\r\n.surgical-action-button:hover {\r\n  background: #edeff0;\r\n}\r\n\r\n.surgical-content {\r\n  height: 95%;\r\n  max-width: 100%;\r\n  overflow-y: scroll;\r\n  line-height: 1.5;\r\n  color: #374151;\r\n  font-size: 16px;\r\n  padding: 0px 16px;\r\n}\r\n\r\n.surgical-editor {\r\n  width: 100%;\r\n  height: 100%;\r\n  min-height: 65%;\r\n  padding: 16px;\r\n  border: 1px solid #e5e7eb;\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  font-family: inherit;\r\n  resize: none;\r\n  color: #374151;\r\n  background: white;\r\n}\r\n\r\n.surgical-editor:focus {\r\n  outline: none;\r\n}\r\n\r\n.surgical-markdown-content {\r\n  font-size: 14px;\r\n  line-height: 1.6;\r\n  color: #374151;\r\n}\r\n\r\n.surgical-markdown-content h1,\r\n.surgical-markdown-content h2,\r\n.surgical-markdown-content h3,\r\n.surgical-markdown-content h4,\r\n.surgical-markdown-content h5,\r\n.surgical-markdown-content h6 {\r\n  margin-top: 1.5em;\r\n  margin-bottom: 0.5em;\r\n  font-weight: 500;\r\n  color: #111827;\r\n}\r\n\r\n.surgical-markdown-content p {\r\n  margin: 1em 0;\r\n}\r\n\r\n.surgical-markdown-content ul,\r\n.surgical-markdown-content ol {\r\n  margin: 1em 0;\r\n  padding-left: 1.5em;\r\n}\r\n\r\n.surgical-markdown-content li {\r\n  margin: 0.5em 0;\r\n}\r\n\r\n.surgical-recording-status-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.surgical-timer-container {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border: 1px solid #e5e7eb;\r\n  border-radius: 6px;\r\n  background: white;\r\n}\r\n\r\n.surgical-mic-icon {\r\n  width: 20px;\r\n  height: 20px;\r\n  color: #0d9488;\r\n}\r\n\r\n.surgical-timer {\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #374151;\r\n}\r\n\r\n.surgical-waveform {\r\n  margin-left: 8px;\r\n}\r\n\r\n.recording-message {\r\n  text-align: center;\r\n}\r\n\r\n.recording-message h3 {\r\n  font-size: 18px;\r\n  color: #374151;\r\n  margin-bottom: 8px;\r\n}\r\n\r\n.recording-message p {\r\n  color: #6b7280;\r\n  font-size: 14px;\r\n}\r\n\r\n\r\n\r\n.audio-player {\r\n  height: 15%;\r\n  width: 100%;\r\n  border-top: 1px solid #e5e7eb;\r\n  padding-top: 16px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.audio-info {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  margin-bottom: 12px;\r\n  color: #374151;\r\n  font-size: 14px;\r\n}\r\n\r\n.recording-name {\r\n  font-weight: 500;\r\n}\r\n\r\n.audio-controls {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.play-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #374151;\r\n  padding: 8px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.play-button:hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n.progress-bar-container {\r\n  flex: 1;\r\n  position: relative;\r\n}\r\n\r\n.progress-bar {\r\n  width: 100%;\r\n  height: 4px;\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  background: #e5e7eb;\r\n  border-radius: 2px;\r\n  outline: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.progress-bar::-webkit-slider-thumb {\r\n  -webkit-appearance: none;\r\n  appearance: none;\r\n  width: 12px;\r\n  height: 12px;\r\n  background: #0d9488;\r\n  border-radius: 50%;\r\n  cursor: pointer;\r\n}\r\n\r\n.audio-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.audio-action-button {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: #374151;\r\n  padding: 8px;\r\n  border-radius: 50%;\r\n}\r\n\r\n.audio-action-button:hover {\r\n  background: #f3f4f6;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .surgical-container {\r\n    padding: 10px;\r\n    overflow: auto;\r\n  }\r\n  .surgical-actions {\r\n    padding-right: 20px;\r\n  }\r\n  .surgical-markdown-content {\r\n    font-size: 14px;\r\n    line-height: 1.4;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
